import { render, staticRenderFns } from "./FormBaseAnsesPersonasJuridicas.vue?vue&type=template&id=b0c9e434"
import script from "./FormBaseAnsesPersonasJuridicas.vue?vue&type=script&lang=js"
export * from "./FormBaseAnsesPersonasJuridicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports